import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import comparisonModuleStyles from '../resources/static/less/comparison-components.module.less';

import ArrowIcon from './ArrowIcon';
import componentStyles from './ShowMoreProviders.module.less';

const createClassNames = (classNames) =>
  classNames.map((className) => `${comparisonModuleStyles[className]}`).join(' ');

const ShowMoreProviders = ({ isExpanded, onToggle, styles }) => {
  const derivedStyle = styles.toggle || componentStyles.toggle;
  const messageId = isExpanded ? 'show-less-providers' : 'show-more-providers';
  return (
    <button
      type="button"
      className={`${derivedStyle} ${createClassNames(['anchor'])}`}
      onClick={() => {
        onToggle();
      }}
      data-testid="show-more-providers"
    >
      <FormattedMessage id={messageId} />
      <ArrowIcon iconPosition={isExpanded ? 'up' : 'down'} />
    </button>
  );
};

ShowMoreProviders.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
  styles: PropTypes.shape({
    toggle: PropTypes.string,
  }),
};

ShowMoreProviders.defaultProps = {
  onToggle: () => {},
  styles: {},
};

export default ShowMoreProviders;
